module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-edna.d0ef3072.png";